import { cn } from "../../utils/classNames";
import hookdLogo from "./hookd_logo.png";

const sizeClasses = {
  nav: "h-14 w-auto sm:h-16",
  compact: "h-12 w-auto",
  hero: "h-24 w-auto sm:h-32",
  full: "h-28 w-auto sm:h-40",
};

export default function Logo({ size = "nav", className = "" }) {
  return (
    <img
      src={hookdLogo}
      alt="Hook'd Curatress"
      className={cn("object-contain drop-shadow-[0_0_18px_rgba(255,60,172,0.32)]", sizeClasses[size] || sizeClasses.nav, className)}
    />
  );
}
